import './FixedMenu.scss';

import cn from 'classnames';
import React, { useEffect } from 'react';

import {
  MENU_TYPE_FIXED,
  useHeaderMenuContext,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import {
  FixedMenuDefaultProps,
  FixedMenuPropTypes,
} from './FixedMenu.proptypes';

const FixedMenu = ({ className }) => {
  const {
    isOpen: isMenuOpen,
    handleClose,
    getPlacement,
    content,
  } = useHeaderMenuContext();
  const isOpen = isMenuOpen({ type: MENU_TYPE_FIXED });

  useEffect(() => {
    if (isOpen) {
      const handleClickOutside = () => {
        handleClose();
      };
      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }

    return () => null;
  }, [handleClose, isOpen]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  if (!isOpen) return null;

  return (
    <div
      role="presentation"
      className={cn(
        className,
        'header-fixed-menu',
        `header-fixed-menu--${getPlacement(MENU_TYPE_FIXED)}`,
      )}
      onClick={handleClick}
    >
      {content}
    </div>
  );
};

FixedMenu.defaultProps = {
  ...FixedMenuDefaultProps,
};

FixedMenu.propTypes = {
  ...FixedMenuPropTypes,
};

export default FixedMenu;
